import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

export async function getEmailRecipientsData() {
  const response = await axios.get('/EmailRecipient/EmailRecipients');
  return response;
}

export async function getRecipientTypesData() {
  const response = await axios.get(`/EmailRecipient/RecipientTypes`);
  return response;
}

export async function postEmailRecipientForm(form) {
  const response = await axios.post('EmailRecipient/EmailRecipientForm', objectToFormData({
    email: form.email,
    id: form.id,
    notificationType: form.notificationType,
    recipientType: form.recipientType,
    siteId: form.siteId,
  }));
  return response;
}

export async function deleteEmailRecipientData(id, siteId) {
  const response = await axios.post('/EmailRecipient/DeleteEmailRecipient', objectToFormData({ id, siteId}));
  return response;
}